import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { Error404Component } from './components/errors/error 404/error-404.component';
import { ControllerSocketService } from './services/sockets/backend-controller/controller.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, Error404Component],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements AfterViewInit {
  private authSubscription?: Subscription;
  auth?: boolean;

  constructor(
    private socketService: ControllerSocketService,
    private router: Router
  ) {}
  ngAfterViewInit(): void {
    this.authSubscription = this.socketService
      .onEvent('auth')
      .subscribe((auth) => {
        if (!auth) {
          this.auth = false;
        } else {
          this.auth = true;
        }
      });
    // Detect refresh or close tab
    window.addEventListener('beforeunload', this.onWindowUnload.bind(this));
  }

  ngOnDestroy(): void {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }

    window.removeEventListener('beforeunload', this.onWindowUnload.bind(this));
  }

  onWindowUnload(event: BeforeUnloadEvent): void {
    this.socketService.emitEvent('manualDisconnect', null);
  }
}
